import { Component, ChangeDetectionStrategy, input, output, signal } from '@angular/core';

import { InputTextModule } from '@openng/optimus-ui/inputtext';
import { ButtonModule } from '@openng/optimus-ui/button';
import { TooltipModule } from '@openng/optimus-ui/tooltip';

import { OpenSearchCriteria } from 'src/app/models/open-search-criteria.model';

/**
 * Free-text OpenSearch document search.
 */
@Component({
	selector: 'app-text-search',
	imports: [InputTextModule, ButtonModule, TooltipModule],
	templateUrl: './text-search.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrl: './text-search.component.scss',
})
export class TextSearchComponent {
	/** Whether an environment is selected — gates the search button (can't search without one). */
	readonly hasEnvironment = input<boolean>(false);

	/** Emits the trimmed term when the user submits (Enter or button). */
	readonly textSearch = output<OpenSearchCriteria>();

	/** The current term in the input. */
	readonly searchTerm = signal<string>('');

	/**
	 * Submits the search when the term is non-empty (Enter key or Search button).
	 */
	public onTextSearch(): void {
		const term = this.searchTerm().trim();
		if (term) {
			this.textSearch.emit({ searchTerm: term });
		}
	}

	/**
	 * Tracks the input value.
	 * @param value
	 */
	public onSearchTermChange(value: string): void {
		this.searchTerm.set(value);
	}
}
